angular
    .module('dnecom.component.product')
    .directive('productWatermark', ["$compile", "$templateCache", "$rootScope", "WatermarkUtils", function ($compile, $templateCache, $rootScope, WatermarkUtils) {
        return {
            scope: {
                'enabled': '=',
                'type': '=',
                'contentType': '=',
                'backgroundColor': '=',
                'discountAmount': '='
            },
            template: '<span class="product-watermark product-watermark-{{ normalizedType }} product-watermark-{{ normalizedType }}-{{ normalizedContentType }}"><ng-transclude></ng-transclude></span>',
            restrict: 'E',
            transclude: true,
            replace: true,
            link: function (scope, element) {
                if (!scope.enabled
                    || !scope.type
                    || !scope.contentType
                    || !scope.backgroundColor
                ) {
                    return;
                }

                scope.normalizedType = scope.type.replace('_', '-').toLowerCase();
                scope.normalizedContentType = scope.contentType.replace('_', '-').toLowerCase();

                // Define template scope
                var templateScope = $rootScope.$new(true);
                templateScope.watermarkDiscountAmount = scope.discountAmount;
                templateScope.watermarkColor = scope.backgroundColor;
                templateScope.watermarkDarkerColor = tinycolor(scope.backgroundColor).darken(8).toString();
                templateScope.watermarkDarkestColor = tinycolor(scope.backgroundColor).darken(15).toString();

                // Get watermark
                WatermarkUtils.get(scope.normalizedType, scope.normalizedContentType).then(function (watermark) {
                    element.append($compile(watermark)(templateScope));
                });
            }
        };
    }]);